
import { defineComponent, PropType, reactive, provide, ref } from "vue";
export default defineComponent({
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      },
    },

    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },

    filter: {
      type: Array as PropType<any[]>,
      default: (): any => [],
    },

    source: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const form: any = ref({});
    provide("filter", props.filter);
    provide("source", props.source);

    const validateFn = () => {
      let result = false;
      form.value.validate((valid: boolean) => {
        result = valid;
      });
      return result;
    };

    return {
      form,
      validateFn,
    };
  },
  /****************************************************************
   *
   *
   *
   ***************************************************************/
});
